import { latestEpisodes, newAnime } from "@/mocks/anime";

export default function UpdateZone() {
  return (
    <section id="update" className="section-pad">
      <div className="container-site">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-accent-600">New Update</span>
            <h2 className="mt-1 font-heading text-3xl md:text-4xl">最新更新 · 追番不错过</h2>
            <p className="mt-2 text-sm text-foreground-600">新剧集持续上线，进度自动记录，跟着更新节奏一口气追完。</p>
          </div>
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex flex-col gap-3">
              {latestEpisodes.map((ep) => (
                <a
                  key={ep.id}
                  href="#binge"
                  className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100 p-3 transition-all duration-300 hover:border-accent-300 hover:bg-background-50"
                >
                  <div className="relative h-[74px] w-[124px] shrink-0 overflow-hidden rounded-xl">
                    <img
                      src={ep.image}
                      alt={`${ep.title} ${ep.episode}`}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <span className="absolute inset-0 grid place-items-center bg-foreground-950/40 opacity-0 transition-opacity group-hover:opacity-100">
                      <i className="ri-play-fill text-xl text-background-50" />
                    </span>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate font-heading text-base text-foreground-950">{ep.title}</h3>
                    <p className="mt-0.5 truncate text-xs text-primary-600">{ep.episode}</p>
                    <p className="mt-1 text-[11px] text-foreground-500">{ep.time}</p>
                  </div>
                  <i className="ri-arrow-right-line shrink-0 text-lg text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="mb-4 font-heading text-xl text-foreground-950">本周新番上架</h3>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
              {newAnime.map((anime) => (
                <a
                  key={anime.id}
                  href="#binge"
                  className="group overflow-hidden rounded-2xl bg-background-100 card-shadow transition-transform duration-300 hover:-translate-y-1"
                >
                  <div className="relative h-[170px] overflow-hidden md:h-[210px]">
                    <img
                      src={anime.image}
                      alt={`${anime.title} 卡通动漫综合高清全集`}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    {anime.badge && (
                      <span className="absolute left-2 top-2 rounded-full bg-primary-500 px-2 py-0.5 text-[10px] text-background-50">
                        {anime.badge}
                      </span>
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent" />
                    <div className="absolute bottom-2 left-3 right-3 flex items-end justify-between gap-2">
                      <span className="truncate font-heading text-sm text-background-50">{anime.title}</span>
                      <span className="shrink-0 rounded-full bg-foreground-950/55 px-2 py-0.5 text-[10px] text-background-100/90">
                        {anime.status}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between px-3 py-2.5">
                    <span className="text-[11px] text-foreground-500">{anime.category}</span>
                    <span className="flex items-center gap-1 text-[11px] text-secondary-600">
                      <i className="ri-star-fill text-secondary-500" />
                      {anime.score}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}